const JSON_TARGETS = [
  { targetDealKey: "resMainCalc1", dealNameKey: "firstPrettyName" },
  { targetDealKey: "resMainCalc2", dealNameKey: "secondPrettyName" }
];

const JSON_TAX_TYPES = [
  { dealTaxType: "mutav", routeFlag: "needsMutav", label: "קובץ מס מוטב" },
  { dealTaxType: "linear", routeFlag: "needsRegTax", label: "קובץ לינארי ישן" }
];

export function get49aJsonExportGroups(sampleForDocsCreation, optionKey) {
  if (!sampleForDocsCreation) return [];

  return JSON_TARGETS.map(({ targetDealKey, dealNameKey }) => {
    const targetResMainCalc = sampleForDocsCreation[targetDealKey];
    const preCalcPartsData = targetResMainCalc?.data?.preCalc?.preCalcPartsData || [];

    const files = preCalcPartsData.reduce((result, currentPart, dealIndex) => {
      JSON_TAX_TYPES.forEach(({ dealTaxType, routeFlag, label }) => {
        if (currentPart?.[routeFlag]) {
          result.push({ dealTaxType, dealIndex, label });
        }
      });
      return result;
    }, []);

    return {
      optionKey,
      targetDealKey,
      dealName: sampleForDocsCreation[dealNameKey] || "",
      files
    };
  }).filter((group) => group.files.length);
}
